<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>图片上传组件技能库</h2>
      <p>展示Element UI Upload组件的图片上传用法，支持多文件、拖拽、预览等功能</p>
    </div>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <CodeCard 
          title="图片上传组件" 
          description="支持多文件上传、图片预览、格式校验(jpg/png)、大小限制(5MB)"
          :codeContent="uploadCode">
          <ImageUpload ref="imageUpload" @upload-success="onUploadSuccess" />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import ImageUpload from './components/ImageUpload.vue'

export default {
  name: 'PcUpload',
  components: {
    CodeCard,
    ImageUpload
  },
  data() {
    return {
      uploadCode: `<template>
  <div class="upload-wrapper">
    <el-upload
      class="image-uploader"
      action="http://localhost:3000/api/upload"
      :headers="headers"
      :multiple="true"
      :limit="limit"
      :file-list="fileList"
      list-type="picture-card"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      accept=".jpg,.jpeg,.png">
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip">
        支持 jpg/png 格式，单个文件不超过 5MB，最多上传 {{ limit }} 张
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      uploadedFiles: [],
      limit: 10,
      headers: {}
    }
  },
  methods: {
    // 上传前校验
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isJPG && !isPNG) {
        this.$toast.error('只支持 jpg/png 格式的图片!')
        return false
      }
      if (!isLt5M) {
        this.$toast.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },

    // 上传成功
    handleSuccess(response, file) {
      if (response.success) {
        this.$toast.success(\`\${file.name} 上传成功!\`)
        this.uploadedFiles.push(response.data)
      }
    },

    // 上传失败
    handleError(err, file) {
      this.$toast.error(\`\${file.name} 上传失败\`)
    },

    // 超出限制
    handleExceed() {
      this.$toast.warning(\`最多只能上传 \${this.limit} 张图片!\`)
    }
  }
}
<\/script>

<style scoped>
.upload-wrapper {
  padding: 20px;
}
.el-upload__tip {
  color: #606266;
  margin-top: 10px;
}
<\/style>`
    }
  },
  methods: {
    onUploadSuccess(data) {
      console.log('上传成功:', data)
    }
  }
}
</script>

<style scoped>
/* 全局样式已由 global.scss 提供 */
</style>
